import { render } from "./claimList.vue?vue&type=template&id=676d0fc4&scoped=true"
import script from "./claimList.vue?vue&type=script&lang=js"
export * from "./claimList.vue?vue&type=script&lang=js"

import "./claimList.vue?vue&type=style&index=0&id=676d0fc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-676d0fc4"]])

export default __exports__